const EDITABLE_INPUT_TYPES = ['text', 'password', 'search', 'tel', 'url', 'email', 'number'];

function remoteDigit(event: KeyboardEvent): string {
  const key = event.key || '';
  const code = event.keyCode || event.which || 0;
  if (/^[0-9]$/.test(key)) return key;
  if (code >= 48 && code <= 57) return String(code - 48);
  if (code >= 96 && code <= 105) return String(code - 96);
  return '';
}

function isTvRuntime(): boolean {
  const runtime = window as any;
  return Boolean(runtime.tizen || runtime.webOS || runtime.webOSSystem);
}

export function installRemoteInputDigits(): () => void {
  const onKeyDown = (event: KeyboardEvent) => {
    if (!isTvRuntime()) return;

    const active = document.activeElement;
    const input = active instanceof HTMLInputElement ? active : null;
    const textarea = active instanceof HTMLTextAreaElement ? active : null;
    const field = input || textarea;
    const digit = remoteDigit(event);
    if (!field || !digit || field.disabled || field.readOnly) return;
    if (input && !EDITABLE_INPUT_TYPES.includes(input.type || 'text')) return;

    event.preventDefault();
    event.stopPropagation();
    const start = field.selectionStart == null ? field.value.length : field.selectionStart;
    const end = field.selectionEnd == null ? start : field.selectionEnd;
    const next = field.value.slice(0, start) + digit + field.value.slice(end);
    const prototype = input ? HTMLInputElement.prototype : HTMLTextAreaElement.prototype;
    const setter = Object.getOwnPropertyDescriptor(prototype, 'value')?.set;
    if (setter) setter.call(field, next);
    else field.value = next;
    try { field.setSelectionRange(start + 1, start + 1); } catch { /* number inputs */ }
    field.dispatchEvent(new Event('input', { bubbles: true }));
  };

  document.addEventListener('keydown', onKeyDown, true);
  return () => document.removeEventListener('keydown', onKeyDown, true);
}
